import { useProduct } from '@/entities/product';
import { getOneTimePriceDisplay, type PriceDisplay } from '@/widgets/product-details/price/lib';

export const useOneTimePrice = (): PriceDisplay | null => {
    const { product } = useProduct();

    if (!product) return null;

    return getOneTimePriceDisplay(product);
};
